export const PRIMARY_LABEL_TEST_ID = 'primary-label';
export const DELIVERY_LABEL_TEST_ID = 'delivery-label';

export const PRICE = 'price';
export const PREVIOUS_PRICE = 'previous-price';

export const DELIVERY_EVENT_LABEL_TEST_ID = 'delivery-event-label';
